// import { useState, useEffect, useRef } from 'react';
// import { Box, Paper, Grid, TextField, Autocomplete, Typography, Button, Dialog, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, Snackbar, Alert, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
// import axios from 'axios';
// import ClientMaster from '../../ClientMaster';
// import LeadSourceMaster from './LeadSourceMaster';
// import ActivityMaster from './ActivityMaster';
// import CurrencyMaster from '../../CurrencyMaster';
// import LeadStatusMaster from './LeadStatusMaster';
// import UserMaster from '../../UserMaster';
// import { useAuth } from '../../../context/AuthContext';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';
// import { useTheme, useMediaQuery } from '@mui/material';
// import { toProperCase } from '../../../utils/formatRows';


// const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));

// export default function ClientDetails({ initialData = {}, onNext, mode, connectionString, disablePartyName = false }) {
//     // const API = 'http://103.251.218.254:91/api';
//     const API = connectionString;
//     const { user, selectedCompany, loading } = useAuth();
//     const companyId = selectedCompany?.CompId || null;
//     const partyDropdownRef = useRef(null);
//     console.log('initialData:', initialData);
//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

//     // â”€â”€â”€ client search state â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     const [companyName, setCompanyName] = useState(initialData.companyName || '');
//     const [BookName, setBookName] = useState('SALE');
//     const [selectedClientId, setSelectedClientId] = useState(initialData.clientId || null);
//     const [searchResults, setSearchResults] = useState([]);
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [clientError, setClientError] = useState(false);

//     const [transactionType, setTransactionType] = useState(initialData.transactionType || '')
//     const isTransactionTypeValid = Boolean(transactionType);
//     const [touchedTxnType, setTouchedTxnType] = useState(false);
//     const [selectedGSTNum, setSelectedGSTNum] = useState("")

//     // â”€â”€â”€ other form state â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     const [details, setDetails] = useState(initialData.details || []);
//     const [error, setError] = useState('');
//     const [quotationNumber, setquotationNumber] = useState(initialData.quotationNumber || '');
//     // normalize invoice/inquiry date to startOf('day') for consistent date-only handling
//     const [qoutationDate, setqoutationDate] = useState(() => {
//         if (mode === 'add' || mode === 'ref') return dayjs().startOf('day');
//         if (initialData.inquiryDate && dayjs(initialData.inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
//             return dayjs(initialData.inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
//         }
//         if (initialData.qoutationDate && dayjs(initialData.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
//             return dayjs(initialData.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
//         }
//         return null;
//     });
//     const [referenceNumber, setReferenceNumber] = useState(initialData.referenceNumber || '');
//     const [referenceDate, setReferenceDate] = useState(() => {
//         const refDateValue = initialData.referenceDate || initialData.RefDate;
//         return refDateValue && dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
//             ? dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day')
//             : null;
//     });
//     const [exchangeRate, setExchangeRate] = useState(initialData.exchangeRate || '');
//     const [qnextFollowUpDate, setqnextFollowUpDate] = useState(() => {
//         return initialData.nextFollowUpDate && dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
//             ? dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day')
//             : dayjs().add(7, 'day').startOf('day');
//     });
//     const [kindAttend, setKindAttend] = useState(initialData.kindAttend || '');
//     const [project, setProject] = useState(initialData.project || '');
//     const [agentName, setAgentName] = useState(initialData.agentName || initialData.AgentName || '');
//     const [agentCommission, setAgentCommission] = useState(initialData.AgentComm || initialData.agentCommission || '');
//     const [remark, setRemark] = useState(initialData.remark || initialData.remarks || '');

//     // â”€â”€â”€ masters & popups â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     const [currencyOptions, setCurrencyOptions] = useState([]);
//     const [selectedCurrency, setSelectedCurrency] = useState(initialData.selectedCurrency || null);
//     const [selectedLeadSource, setSelectedLeadSource] = useState(initialData.selectedLeadSource || null);
//     const [selectedEmployee, setSelectedEmployee] = useState(initialData.selectedEmployee || null);
//     const [selectedActivity, setSelectedActivity] = useState(initialData.selectedActivity || null);
//     const [selectedStatus, setSelectedStatus] = useState(initialData.selectedStatus || null);

//     const [openClientPopup, setOpenClientPopup] = useState(false);
//     const [openCurrencyPopup, setOpenCurrencyPopup] = useState(false);
//     const [openLeadSourcePopup, setOpenLeadSourcePopup] = useState(false);
//     const [openEmployeePopup, setOpenEmployeePopup] = useState(false);
//     const [openActivityPopup, setOpenActivityPopup] = useState(false);
//     const [openStatusPopup, setOpenStatusPopup] = useState(false);

//     const [salesAC, setSalesAC] = useState(initialData.salesAC || '');
//     const [selectedSalesACId, setSelectedSalesACId] = useState(initialData.salesACId || null);
//     const [salesACResults, setSalesACResults] = useState([]);
//     const [salesACDropdownOpen, setSalesACDropdownOpen] = useState(false);
//     const salesACDropdownRef = useRef(null);

//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: "",
//         severity: "success"
//     });

//     const requiredAsteriskStyle = {
//         '& .MuiFormLabel-asterisk': {
//             color: 'red',
//         },
//     };

//     const handlePopupClose = (data) => {
//         if (data?.success) {
//             setSnackbar({
//                 open: true,
//                 message: data.message,
//                 severity: "success"
//             });
//         }
//     };

//     useEffect(() => {
//         if (mode !== 'add' && mode !== 'ref') return;
//         if (!companyId) return;

//         const fetchDefaultSalesAC = async () => {
//             try {
//                 const res = await axios.get(`${API}/api/company-search`, {
//                     params: {
//                         field: 'FirmName',
//                         search: 'Sales A/C',
//                         companyId,
//                         limit: 10
//                     }
//                 });

//                 const data = Array.isArray(res.data.data) ? res.data.data : [];
//                 const exactMatch = data.find(r => r.FirmName?.toLowerCase() === 'sales a/c');
//                 const selected = exactMatch || data[0];

//                 if (selected) {
//                     setSalesAC(selected.FirmName || '');
//                     setSelectedSalesACId(selected.id || null);
//                 }
//             } catch (err) {
//                 console.error('Error fetching default Sales A/C:', err);
//             }
//         };

//         fetchDefaultSalesAC();
//     }, [companyId, mode, API]);

//     useEffect(() => {
//         if (!salesACDropdownOpen || !salesAC) {
//             setSalesACResults([]);
//             return;
//         }

//         const fetchSalesAC = async () => {
//             try {
//                 const res = await axios.get(`${API}/api/company-search`, {
//                     params: {
//                         field: 'FirmName',
//                         search: salesAC,
//                         companyId
//                     }
//                 });

//                 const data = Array.isArray(res.data.data) ? res.data.data : [];
//                 setSalesACResults(data);
//             } catch (err) {
//                 console.error('Error fetching Sales A/C results:', err);
//                 setSalesACResults([]);
//             }
//         };

//         fetchSalesAC();
//     }, [salesAC, salesACDropdownOpen, companyId, API]);

//     // â”€â”€â”€ load auto-generated inquiry number â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     useEffect(() => {
//         fetchReceiptNo('Q');
//     }, []);

//     async function fetchReceiptNo(code) {
//         if (mode !== 'edit') {
//             try {
//                 const { data } = await axios.get(`${API}/api/get-sale-order-no`, {
//                     params: {
//                         companyId: companyId   // ðŸ‘ˆ ADD HERE
//                     }
//                 });
//                 console.log(data);
//                 setquotationNumber(data.invoiceNumber || '');
//             } catch {
//                 setquotationNumber('');
//             }
//         }
//     }

//     useEffect(() => {
//         // Do NOT auto-change if user has manually selected
//         if (touchedTxnType) return;

//         // Do NOT override edit mode value if it exists
//         if (mode === "edit" && initialData.transactionType) return;

//         // IMPORTANT: GST not yet evaluated
//         if (selectedGSTNum === "") return;

//         if (selectedGSTNum) {
//             setTransactionType("regular");
//         } else {
//             setTransactionType("unregisteredPersons");
//         }
//     }, [selectedGSTNum, touchedTxnType, mode, initialData.transactionType]);

//     // â”€â”€â”€ load all master-lists â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     useEffect(() => {
//         const fetchMasters = async () => {
//             try {
//                 const [cur] = await Promise.all([axios.get(`${API}/currencymaster/search?mode=search&companyId=${companyId}`)]);
//                 setCurrencyOptions(transform(cur.data, 'CurrencyId', 'CurrencySymbol'));
//             } catch (err) {
//                 console.error(err);
//             }
//         };
//         fetchMasters();
//     }, []);

//     // â”€â”€â”€ currency selection â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     useEffect(() => {
//         if (!currencyOptions || currencyOptions.length === 0 || !initialData?.currencyId) {
//             setSelectedCurrency(null);
//             return;
//         }
//         const found = currencyOptions.find(opt => String(opt.id) === String(initialData.currencyId));
//         setSelectedCurrency(found || null);
//     }, [currencyOptions, initialData.currencyId]);

//     // â”€â”€â”€ dropdownField with popup support â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     const dropdownField = (label, options, value, setValue) => (
//         <Grid item xs={12} sm={8} md={12}>
//             <Autocomplete fullWidth options={options} getOptionLabel={opt => opt?.label || ''} value={value} onChange={(_, v) => setValue(v)} isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)} disabled={!isEditable}
//                 renderInput={params => (
//                     <TextField {...params} label={label} size="small" InputLabelProps={{ shrink: Boolean(value) }}
//                         sx={{
//                             '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                             '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                         }}
//                     />
//                 )}
//             />
//         </Grid>
//     );

//     // â”€â”€â”€ initialize from initialData â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     useEffect(() => {
//         if (!initialData || Object.keys(initialData).length === 0) {
//             if (mode === 'add' || mode === 'ref') {
//                 setqoutationDate(dayjs().startOf('day'));
//                 setReferenceNumber('');
//                 setReferenceDate(null);
//             }
//             return;
//         }

//         // For add/ref ALWAYS use today's date for Invoice (ignore incoming inquiryDate)
//         if (mode === 'add' || mode === 'ref') {
//             setqoutationDate(dayjs().startOf('day'));
//         }

//         setCompanyName(initialData.companyName || '');
//         setSelectedClientId(initialData.clientId ?? null);

//         if (initialData.details) {
//             if (Array.isArray(initialData.details)) {
//                 setDetails(initialData.details);
//             } else if (typeof initialData.details === 'object') {
//                 const arr = Object.entries(initialData.details).map(([label, value]) => ({ label, value }));
//                 setDetails(arr);
//             }
//         } else {
//             const c = {
//                 city: initialData.city || '',
//                 state: initialData.state || '',
//                 mobileNo: initialData.mobileNo || '',
//                 emailId: initialData.emailId || '',
//                 contactPerson: initialData.contactPerson || '',
//                 gstNumber: initialData.gstNumber || ''
//             };
//             setDetails([
//                 { label: 'City', value: c.city },
//                 { label: 'State', value: c.state },
//                 { label: 'mobileNo', value: c.mobileNo },
//                 { label: 'Email', value: c.emailId },
//                 { label: 'ContactPerson', value: c.contactPerson },
//                 { label: 'GST No.', value: c.gstNumber }
//             ]);
//         }

//         setSelectedLeadSource(initialData.selectedLeadSource || null);
//         setSelectedEmployee(initialData.selectedEmployee || null);
//         setSelectedActivity(initialData.selectedActivity || null);
//         setSelectedStatus(initialData.selectedStatus || null);

//         // Initialize quotation date: only populate from initialData when editing
//         if (mode === 'edit') {
//             const inquiryDate = initialData.inquiryDate || initialData.qoutationDate;
//             setqoutationDate(
//                 inquiryDate && dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
//                     ? dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day')
//                     : dayjs().startOf('day')
//             );
//         }

//         if (mode === 'edit') {
//             setSalesAC(initialData.salesAC || '');
//             setSelectedSalesACId(initialData.salesACId || null);
//         }

//         // Initialize reference date and number
//         if (mode === 'add') {
//             setReferenceNumber(initialData.referenceNumber || '');
//         } else {
//             setReferenceNumber(initialData.referenceNumber || '');
//             const refDateValue = initialData.referenceDate || initialData.RefDate;
//             setReferenceDate(
//                 refDateValue && dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
//                     ? dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day')
//                     : null
//             );
//         }
//         if (mode === "ref") {
//             setReferenceNumber(initialData.quotationNumber);
//         }

//         setExchangeRate(initialData.exchangeRate || '');
//         setqnextFollowUpDate(
//             initialData.nextFollowUpDate && dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
//                 ? dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day')
//                 : dayjs().add(7, 'day').startOf('day')
//         );
//         setKindAttend(initialData.kindAttend || '');
//         setProject(initialData.project || '');
//         setAgentName(initialData.AgentName || initialData.agentName || '');
//         setAgentCommission(initialData.AgentComm || initialData.agentCommission || '');
//         setRemark(initialData.remark || initialData.remarks || '');
//         setTransactionType(
//             initialData.transactionType || ""
//         );

//         if (mode === 'edit') {
//             setquotationNumber(initialData.quotationNumber || '');
//         }
//     }, [initialData, mode]);

//     // â”€â”€â”€ fetch search results â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     useEffect(() => {
//         if (!companyName || !dropdownOpen) {
//             setSearchResults([]);
//             return;
//         }

//         const fetch = async () => {
//             try {
//                 const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', search: companyName, companyId } });
//                 const data = Array.isArray(res.data.data) ? res.data.data : [];
//                 console.log('Company search results:', data);
//                 setSearchResults(data);
//             } catch (err) {
//                 console.error('Error fetching company search results:', err);
//                 setSearchResults([]);
//             }
//         };
//         fetch();
//     }, [companyName, dropdownOpen]);

//     // â”€â”€â”€ Handle row selection in table â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     const onSelectResult = r => {
//         setSelectedClientId(r.id);
//         setSelectedGSTNum(r.GSTNo);
//         setTouchedTxnType(false)
//         setCompanyName(r.FirmName || r.companyName || '');
//         setAgentName(r.AgentName || '');
//         setAgentCommission(r.AgentComm || '');

//         const c = {
//             City: r.City || '',
//             state: r.state || '',
//             MobileNo: r.MobileNo || '',
//             EmailId: r.EmailId || '',
//             ContactPerson: r.ContactPerson || '',
//             GSTNo: r.GSTNo || ''
//         };
//         setDetails([
//             { label: 'City', value: c.City },
//             { label: 'State', value: c.state },
//             { label: 'mobileNo', value: c.MobileNo },
//             { label: 'Email', value: c.EmailId },
//             { label: 'ContactPerson', value: c.ContactPerson },
//             { label: 'GST No.', value: c.GSTNo }
//         ]);
//         setDropdownOpen(false);
//         setClientError(false);

//     };

//     // â”€â”€â”€ Next button â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     const handleNext = () => {
//         if (mode === 'add' && !companyName) {
//             setError('Party Name is required.');
//             return;
//         }
//         if (!companyName && !quotationNumber) {
//             setError('Party & Inquiry No. are required.');
//             return;
//         }
//         if (!selectedClientId) {
//             setClientError(true);
//             return;
//         }

//         // log date-only values (local) so you can see IST dates
//         console.log(
//             'qnextFollowUpDate:', qnextFollowUpDate ? dayjs(qnextFollowUpDate).format('DD/MM/YYYY') : null,
//             '| qoutationDate:', qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : null,
//             '| referenceDate:', referenceDate ? dayjs(referenceDate).format('DD/MM/YYYY') : null
//         );

//         setError('');
//         onNext({
//             clientId: selectedClientId,
//             companyName,
//             BookName,
//             quotationNumber,
//             // send formatted dates (local)
//             inquiryDate: qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : '',
//             referenceNumber,
//             referenceDate: referenceDate ? dayjs(referenceDate).format('DD/MM/YYYY') : '',
//             RefDate: referenceDate ? dayjs(referenceDate).format('YYYY-MM-DD') : '',
//             agentName,
//             agentCommission: agentCommission || 0,
//             currencyId: selectedCurrency?.id || null,
//             exchangeRate: exchangeRate || 0,
//             kindAttend,
//             remarks: remark,
//             project,
//             selectedEmployee,
//             selectedLeadSource,
//             selectedActivity,
//             selectedStatus,
//             transactionType,
//             salesAC,
//             salesACId: selectedSalesACId,
//             details: details.reduce((acc, curr) => {
//                 acc[curr.label] = curr.value;
//                 return acc;
//             }, {})
//         });
//     };

//     // Allow editing only in 'add' or 'edit' modes, but allow date fields in 'ref' mode
//     const isEditable = mode === 'add' || mode === 'edit';
//     const isDateEditable = mode === 'add' || mode === 'edit' || mode === 'ref';

//     return (
//         <Paper elevation={2} sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
//             <Box display="flex" justifyContent="space-between" flexWrap="wrap" pt={1}>
//                 <Box sx={{ width: { xs: "100%", md: "calc(50% - 16px)" }, pr: { md: 3 } }}>
//                     {/* Party dropdown */}
//                     <Box ref={partyDropdownRef} tabIndex={-1} sx={{ position: 'relative', flex: '1 1 40%' }}
//                         onBlur={e => {
//                             if (!partyDropdownRef.current.contains(e.relatedTarget)) {
//                                 setDropdownOpen(false);
//                             }
//                         }}
//                     >
//                         <TextField disabled={!isEditable || disablePartyName} fullWidth size="small" label="Party Name" variant="outlined" error={clientError} value={toProperCase(companyName)} required InputLabelProps={{ shrink: Boolean(companyName), sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: '38px', display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }}
//                             onChange={e => {
//                                 setCompanyName(toProperCase(e.target.value));
//                                 setDropdownOpen(true);
//                                 setSelectedClientId(null);
//                                 setClientError(false);
//                             }}
//                             onBlur={() => {
//                                 if (companyName && !selectedClientId) {
//                                     setClientError(true);
//                                 }
//                             }}
//                             helperText={
//                                 clientError
//                                     ? "Please select a client from the list"
//                                     : ""
//                             }
//                         />
//                         {/* {dropdownOpen && (
//                             <TableContainer component={Paper} elevation={0}
//                                 sx={{ mt: 1, maxHeight: 240, position: 'absolute', width: '120%', zIndex: 10, border: 'none', overflow: 'auto', border: '1px solid rgba(0,0,0,0.2)', borderRadius: 1 }}>
//                                 <Table
//                                     size="small"
//                                     sx={{
//                                         borderCollapse: 'separate',
//                                         borderSpacing: 0,
//                                         tableLayout: 'fixed',              // force cells to obey widths
//                                         '& thead th': {
//                                             backgroundColor: '#1877F2',
//                                             color: '#fff',
//                                             fontWeight: 600,
//                                             fontSize: '0.75rem',
//                                             border: 'none'
//                                         },
//                                         '& th, & td': {                    // reduce padding between columns
//                                             padding: '4px 6px',              // smaller vertical & horizontal padding
//                                             fontSize: '0.75rem',
//                                             overflow: 'hidden',
//                                             textOverflow: 'ellipsis',
//                                             whiteSpace: 'nowrap',
//                                         },
//                                         // option: collapse borders so there is no extra gap
//                                         '& .MuiTableCell-root': {
//                                             borderRight: '0px'               // remove right cell border if any
//                                         }
//                                     }}
//                                 >
//                                     <TableHead>
//                                         <TableRow>
//                                             <TableCell sx={{ width: '30%', maxWidth: 200 }}>Company</TableCell>
//                                             <TableCell sx={{ width: '15%', maxWidth: 120 }}>GST No</TableCell>
//                                             <TableCell sx={{ width: '20%', maxWidth: 140 }}>Contact</TableCell>
//                                             <TableCell sx={{ width: '20%', maxWidth: 120 }}>Mobile</TableCell>
//                                             <TableCell sx={{ width: '15%', maxWidth: 100 }}>City</TableCell>
//                                         </TableRow>
//                                     </TableHead>
//                                     <TableBody sx={{ '& > tr:last-of-type': { borderBottom: '1px solid rgba(0,0,0,0.12)' } }}>
//                                         {searchResults.length > 0 ? (
//                                             searchResults.map((r, i) => (
//                                                 <TableRow key={i} hover onMouseDown={() => onSelectResult(r)} sx={{ cursor: 'pointer', backgroundColor: i % 2 === 0 ? '#fff' : 'rgba(227, 242, 253, 1)', border: 'none' }}>
//                                                     <TableCell sx={{ width: '30%', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.FirmName}</TableCell>
//                                                     <TableCell sx={{ width: '15%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.GSTNo}</TableCell>
//                                                     <TableCell sx={{ width: '20%', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.ContactPerson}</TableCell>
//                                                     <TableCell sx={{ width: '20%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.MobileNo}</TableCell>
//                                                     <TableCell sx={{ width: '15%', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.City}</TableCell>
//                                                 </TableRow>
//                                             ))
//                                         ) : (
//                                             <TableRow>
//                                                 <TableCell colSpan={5} align="center"> No Data Available </TableCell>
//                                             </TableRow>
//                                         )}
//                                     </TableBody>
//                                     <TableFooter sx={{ borderTop: '1px solid rgba(0,0,0,0.12)' }}>
//                                         <TableRow hover sx={{ cursor: 'pointer', backgroundColor: '#fff' }} onMouseDown={() => setOpenClientPopup(true)}>
//                                             <TableCell colSpan={5} sx={{ textAlign: 'center', color: 'primary.main' }}>
//                                                 âž• Add New Client
//                                             </TableCell>
//                                         </TableRow>
//                                     </TableFooter>
//                                 </Table>
//                             </TableContainer>
//                         )} */}
//                         {dropdownOpen && companyName && (
//                             <Paper elevation={0} sx={{ mt: 1, position: 'absolute', width: { xs: '100%', lg: '800px' }, zIndex: 10, border: '1px solid rgba(0,0,0,0.2)', borderRadius: 1, maxHeight: 240, overflowY: 'auto' }} >
//                                 {isSmallScreen ? (
//                                     /* ===================== CARD VIEW (SM / XS) ===================== */
//                                     <>
//                                         {searchResults.length > 0 ? (
//                                             searchResults.map((r, i) => (
//                                                 <Box
//                                                     key={i}
//                                                     sx={{
//                                                         p: 1.2,
//                                                         borderBottom: '1px solid #eee',
//                                                         cursor: 'pointer'
//                                                     }}
//                                                     onMouseDown={() => {
//                                                         onSelectResult(r);

//                                                         // setSelectedClientId(r.ClientId);
//                                                         setCompanyName(toProperCase(r.FirmName));

//                                                         setClientError(false);
//                                                         setDropdownOpen(false);
//                                                     }}
//                                                 >
//                                                     <Box sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
//                                                         {toProperCase(r.FirmName)}
//                                                     </Box>

//                                                     <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
//                                                         GST: {r.GSTNo || '-'}
//                                                     </Box>

//                                                     <Box sx={{ fontSize: '0.75rem' }}>
//                                                         {toProperCase(r.ContactPerson) || '-'} â€¢ {r.MobileNo || '-'}
//                                                     </Box>

//                                                     <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
//                                                         {toProperCase(r.City) || '-'}
//                                                     </Box>
//                                                 </Box>
//                                             ))
//                                         ) : (
//                                             <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}>
//                                                 Client not found
//                                             </Box>
//                                         )}

//                                         {/* Sticky Add New Client */}
//                                         <Box sx={{ position: 'sticky', bottom: 0, backgroundColor: '#fff', textAlign: 'center', p: 1, fontWeight: 600, color: 'primary.main', cursor: 'pointer', boxShadow: '0 -2px 6px rgba(0,0,0,0.08)' }} onMouseDown={() => setOpenClientPopup(true)}  >
//                                             âž• Add New Client
//                                         </Box>
//                                     </>
//                                 ) : (
//                                     /* ===================== TABLE VIEW (MD / LG) ===================== */
//                                     <Table size="small" stickyHeader>
//                                         <TableHead>
//                                             <TableRow>
//                                                 {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map(h => (
//                                                     <TableCell key={h} sx={{ backgroundColor: '#E0E0E0', fontWeight: 600, fontSize: '0.75rem', position: 'sticky', top: 0, zIndex: 1 }} >
//                                                         {h}
//                                                     </TableCell>
//                                                 ))}
//                                             </TableRow>
//                                         </TableHead>

//                                         <TableBody>
//                                             {searchResults.length > 0 ? (
//                                                 searchResults.map((r, i) => (
//                                                     <TableRow key={i} hover sx={{ cursor: 'pointer' }}
//                                                         onMouseDown={() => {
//                                                             onSelectResult(r);

//                                                             setCompanyName(toProperCase(r.FirmName));
//                                                             setClientError(false);
//                                                             setDropdownOpen(false);
//                                                         }}
//                                                     >
//                                                         <TableCell>{toProperCase(r.FirmName)}</TableCell>
//                                                         <TableCell>{r.GSTNo}</TableCell>
//                                                         <TableCell>{toProperCase(r.ContactPerson) || "-"}</TableCell>
//                                                         <TableCell>{r.MobileNo}</TableCell>
//                                                         <TableCell>{toProperCase(r.City)}</TableCell>
//                                                     </TableRow>
//                                                 ))
//                                             ) : (
//                                                 <TableRow>
//                                                     <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}>
//                                                         Client not found
//                                                     </TableCell>
//                                                 </TableRow>
//                                             )}
//                                         </TableBody>

//                                         <TableFooter sx={{ position: 'sticky', bottom: 0, backgroundColor: '#fff' }} >
//                                             <TableRow hover onMouseDown={() => setOpenClientPopup(true)}>
//                                                 <TableCell colSpan={5} align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>
//                                                     âž• Add New Client
//                                                 </TableCell>
//                                             </TableRow>
//                                         </TableFooter>
//                                     </Table>
//                                 )}
//                             </Paper>
//                         )}
//                     </Box>

//                     {/* Details display */}
//                     <Grid item xs={12} md={4} pt={2}>
//                         <TextField fullWidth size="small" label="Address" variant="outlined" disabled value={Array.isArray(details) ? toProperCase(details.map(d => `${d.label}: ${d.value}`).join(', ')) : ''} multiline rows={3} InputLabelProps={{ shrink: Array.isArray(details) && details.length > 0 }} sx={{ '& .MuiOutlinedInput-root': { display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} />
//                     </Grid>

//                     {/* <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField
//                                 fullWidth
//                                 size="small"
//                                 label="Kind Attend"
//                                 value={kindAttend}
//                                 onChange={e => setKindAttend(e.target.value)}
//                                 InputLabelProps={{ shrink: Boolean(kindAttend) }}
//                                 sx={{ '& .MuiOutlinedInput-root': { height:38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
//                             />
//                         </Box>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField
//                                 fullWidth
//                                 size="small"
//                                 label="Project"
//                                 value={project}
//                                 onChange={e => setProject(e.target.value)}
//                                 InputLabelProps={{ shrink: Boolean(project) }}
//                                 sx={{ '& .MuiOutlinedInput-root': { height:38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
//                             />
//                         </Box>
//                     </Box> */}

//                     {/* Remark multiline (max 250 chars) */}
//                     <Box sx={{ mt: 2 }}>
//                         <TextField fullWidth size="small" label="Remark" disabled={!isEditable} multiline minRows={1} maxRows={6} value={remark} InputLabelProps={{ shrink: Boolean(remark) }} inputProps={{ maxLength: 250 }}
//                             onChange={(e) => {
//                                 const val = e.target.value;
//                                 if (val.length <= 250) setRemark(val);
//                                 else setRemark(val.slice(0, 250));
//                             }}
//                             sx={{ '& .MuiOutlinedInput-root': { height: 'auto', alignItems: 'flex-start' } }}
//                         />
//                         <Typography variant="caption" sx={{ display: 'block', mt: 0.5, textAlign: 'right', color: 'text.secondary' }}>
//                             {remark.length}/250
//                         </Typography>
//                     </Box>
//                 </Box>

//                 <Box sx={{ width: { xs: "100%", md: "calc(50% - 46px)" }, pt: { xs: 2, md: 0 } }} alignSelf="right">
//                     {/* Quotation No + Date */}
//                     <Box display="flex" gap={2} flex="1 1 40%">
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth size="small" label="Invoice No." variant="outlined" value={quotationNumber} disabled InputLabelProps={{ shrink: true }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} />
//                         </Box>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                                 <DatePicker label="Invoice Date" value={qoutationDate} onChange={(val) => setqoutationDate(val ? dayjs(val).startOf('day') : null)}
//                                     slots={{
//                                         textField: (params) => (
//                                             <TextField {...params} size="small" fullWidth variant="outlined" value={qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} InputLabelProps={{ shrink: true }} />
//                                         ),
//                                     }}
//                                 />
//                             </LocalizationProvider>
//                         </Box>
//                     </Box>

//                     {/* <Box display="flex" gap={2} flex="1 1 40%" pt={2}>

//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField
//                                 fullWidth
//                                 size="small"
//                                 variant="outlined"
//                                 label="Ref. No."
//                                 value={referenceNumber}
//                                 onChange={e => setReferenceNumber(e.target.value)}
//                                 InputLabelProps={{ shrink: Boolean(referenceNumber) }}
//                                 sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}

//                             />
//                         </Box>


//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                                 <DatePicker
//                                     label="Ref. Date"
//                                     value={referenceDate}
//                                     onChange={(newValue) => setReferenceDate(newValue ? dayjs(newValue).startOf('day') : null)}
//                                     disabled={!isDateEditable}
//                                     slots={{
//                                         textField: (params) => (
//                                             <TextField
//                                                 {...params}
//                                                 fullWidth
//                                                 size="small"
//                                                 variant="outlined"
//                                                 value={referenceDate ? referenceDate.format('DD/MM/YYYY') : ''}
//                                                 InputLabelProps={{ shrink: Boolean(referenceDate) }}
//                                                 sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
//                                             />
//                                         )
//                                     }}
//                                 />
//                             </LocalizationProvider>
//                         </Box>
//                     </Box> */}

//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2} flexDirection={{ xs: 'column', md: 'row' }}>
//                         <Box sx={{ flex: '0 0 48%', display: 'flex', gap: 1, alignItems: 'center' }}>
//                             <Box sx={{ flex: '0 0 50%' }}>
//                                 {dropdownField('Currency', currencyOptions, selectedCurrency, setSelectedCurrency)}
//                             </Box>
//                             <Box sx={{ flex: '0 0 47%' }}>
//                                 <TextField fullWidth size="small" type="number" variant="outlined" label="Ex Rate" value={exchangeRate} InputLabelProps={{ shrink: Boolean(exchangeRate) }}
//                                     onChange={(e) => {
//                                         const value = e.target.value;
//                                         if (/^\d*\.?\d{0,2}$/.test(value)) {
//                                             setExchangeRate(value);
//                                         }
//                                     }}
//                                     sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
//                                 />
//                             </Box>
//                         </Box>

//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <FormControl fullWidth size="small" required sx={{
//                                 '& .MuiFormLabel-asterisk': {
//                                     color: 'red',
//                                 },
//                             }} error={touchedTxnType && !transactionType} >
//                                 <InputLabel>Transaction Type</InputLabel>
//                                 <Select value={transactionType} label="Transaction Type" onChange={(e) => { setTransactionType(e.target.value); setTouchedTxnType(true); }} onBlur={() => setTouchedTxnType(true)} sx={{ height: 38 }} required >
//                                     <MenuItem value="regular">Regular</MenuItem>
//                                     <MenuItem value="unregisteredPersons">Unregistered Persons</MenuItem>
//                                     <MenuItem value="sezExempted">SEZ Exempted</MenuItem>
//                                     <MenuItem value="sezTaxPay">SEZ Tax Pay</MenuItem>
//                                     <MenuItem value="exportWithTaxPay">Export With Tax Pay</MenuItem>
//                                     <MenuItem value="exportWithoutTaxPay">Export Without Tax Pay</MenuItem>
//                                     <MenuItem value="exemptedSupplies">Exempted Supplies</MenuItem>
//                                     <MenuItem value="nilRateSupplies">Nil Rate Supplies</MenuItem>
//                                     <MenuItem value="nonGSTSupplies">Non GST Supplies</MenuItem>
//                                     <MenuItem value="compositeSupplier">Composite Supplier</MenuItem>
//                                     <MenuItem value="uinholders">UIN holders</MenuItem>
//                                     <MenuItem value="zeroRatedSupplies">Zero Rated Supplies</MenuItem>
//                                 </Select>
//                             </FormControl>

//                         </Box>
//                     </Box>

//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth label="Agent Name" value={toProperCase(agentName)} onChange={e => setAgentName(toProperCase(e.target.value))} InputLabelProps={{ shrink: Boolean(agentName) }} variant="outlined" size="small" sx={{ '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '38px' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' } }} />
//                         </Box>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth label="Agent Commission (%)" value={agentCommission} InputLabelProps={{ shrink: Boolean(agentCommission) }} variant="outlined" size="small" type="number"
//                                 onChange={e => {
//                                     const v = e.target.value;
//                                     if (v === '') {
//                                         setAgentCommission('');
//                                         return;
//                                     }
//                                     const re = /^(?:100(?:\.(?:0{0,2}))?|[0-9]{1,2}(?:\.\d{0,2})?)$/;
//                                     if (re.test(v)) {
//                                         setAgentCommission(v);
//                                     }
//                                 }}
//                                 sx={{ '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '38px' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' } }}
//                             />
//                         </Box>
//                     </Box>
//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box
//                             ref={salesACDropdownRef}
//                             tabIndex={-1}
//                             sx={{ flex: '0 0 100%', position: 'relative' }}
//                             onBlur={(e) => {
//                                 if (!salesACDropdownRef.current?.contains(e.relatedTarget)) {
//                                     setSalesACDropdownOpen(false);
//                                 }
//                             }}
//                         >
//                             <TextField
//                                 fullWidth
//                                 label="Sales A/C"
//                                 value={toProperCase(salesAC)}
//                                 disabled={!isEditable}
//                                 InputLabelProps={{ shrink: Boolean(salesAC) }}
//                                 variant="outlined"
//                                 size="small"
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': { height: '38px' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' }
//                                 }}
//                                 onChange={(e) => {
//                                     setSalesAC(e.target.value);
//                                     setSalesACDropdownOpen(true);
//                                     setSelectedSalesACId(null);
//                                 }}
//                                 onFocus={() => {
//                                     if (salesAC) setSalesACDropdownOpen(true);
//                                 }}
//                             />

//                             {salesACDropdownOpen && salesAC && (
//                                 <Paper
//                                     elevation={0}
//                                     sx={{
//                                         mt: 1,
//                                         position: 'absolute',
//                                         width: { xs: '100%', lg: '500px' },
//                                         zIndex: 10,
//                                         border: '1px solid rgba(0,0,0,0.2)',
//                                         borderRadius: 1,
//                                         maxHeight: 240,
//                                         overflowY: 'auto'
//                                     }}
//                                 >
//                                     <Table size="small" stickyHeader>
//                                         <TableHead>
//                                             <TableRow>
//                                                 {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map((h) => (
//                                                     <TableCell
//                                                         key={h}
//                                                         sx={{
//                                                             backgroundColor: '#E0E0E0',
//                                                             fontWeight: 600,
//                                                             fontSize: '0.75rem',
//                                                             position: 'sticky',
//                                                             top: 0,
//                                                             zIndex: 1
//                                                         }}
//                                                     >
//                                                         {h}
//                                                     </TableCell>
//                                                 ))}
//                                             </TableRow>
//                                         </TableHead>

//                                         <TableBody>
//                                             {salesACResults.length > 0 ? (
//                                                 salesACResults.map((r, i) => (
//                                                     <TableRow
//                                                         key={i}
//                                                         hover
//                                                         sx={{ cursor: 'pointer' }}
//                                                         onMouseDown={() => {
//                                                             setSalesAC(r.FirmName);
//                                                             setSelectedSalesACId(r.id);
//                                                             setSalesACDropdownOpen(false);
//                                                         }}
//                                                     >
//                                                         <TableCell>{toProperCase(r.FirmName)}</TableCell>
//                                                         <TableCell>{r.GSTNo || '-'}</TableCell>
//                                                         <TableCell>{toProperCase(r.ContactPerson) || '-'}</TableCell>
//                                                         <TableCell>{r.MobileNo || '-'}</TableCell>
//                                                         <TableCell>{toProperCase(r.City) || '-'}</TableCell>
//                                                     </TableRow>
//                                                 ))
//                                             ) : (
//                                                 <TableRow>
//                                                     <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}>
//                                                         Sales A/C not found
//                                                     </TableCell>
//                                                 </TableRow>
//                                             )}
//                                         </TableBody>
//                                     </Table>
//                                 </Paper>
//                             )}
//                         </Box>
//                     </Box>
//                 </Box>
//             </Box>

//             {!!error && (
//                 <Typography color="error" mt={2}>
//                     {error}
//                 </Typography>
//             )}

//             <Box mt={4} display="flex" justifyContent="flex-end">
//                 <Button variant="contained" onClick={handleNext} disabled={!selectedClientId || !isTransactionTypeValid}>Next</Button>
//             </Box>

//             {/* Popups */}
//             <Dialog open={openClientPopup} fullWidth maxWidth="md" onClose={(event, reason) => {
//                 if (reason === 'backdropClick') return;
//                 setOpenClientPopup(false);
//             }}
//                 PaperProps={{
//                     sx: {
//                         width: { xs: "95%", },
//                         m: { xs: 0 }
//                     }
//                 }}
//             >
//                 <DialogContent sx={{ p: { xs: 0 } }}>
//                     <ClientMaster mode="add" onPopupCancel={(data) => { handlePopupClose(data); setOpenClientPopup(false) }} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openCurrencyPopup} onClose={() => setOpenCurrencyPopup(false)}>
//                 <DialogContent>
//                     <CurrencyMaster mode="add" onPopupCancel={() => setOpenCurrencyPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openLeadSourcePopup} onClose={() => setOpenLeadSourcePopup(false)}>
//                 <DialogContent>
//                     <LeadSourceMaster mode="add" onPopupCancel={() => setOpenLeadSourcePopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openEmployeePopup} onClose={() => setOpenEmployeePopup(false)}>
//                 <DialogContent>
//                     <UserMaster mode="add" onPopupCancel={() => setOpenEmployeePopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openActivityPopup} onClose={() => setOpenActivityPopup(false)}>
//                 <DialogContent>
//                     <ActivityMaster mode="add" onPopupCancel={() => setOpenActivityPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openStatusPopup} onClose={() => setOpenStatusPopup(false)}>
//                 <DialogContent>
//                     <LeadStatusMaster mode="add" onPopupCancel={() => setOpenStatusPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>

//             <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//                 <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }} >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Paper>
//     );
// }








import { useState, useEffect, useRef } from 'react';
import { Box, Paper, Grid, TextField, Autocomplete, Typography, Button, Dialog, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, Snackbar, Alert, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import axios from 'axios';
import ClientMaster from '../../ClientMaster';
import LeadSourceMaster from './LeadSourceMaster';
import ActivityMaster from './ActivityMaster';
import CurrencyMaster from '../../CurrencyMaster';
import LeadStatusMaster from './LeadStatusMaster';
import UserMaster from '../../UserMaster';
import { useAuth } from '../../../context/AuthContext';
import { useConfigure } from '../../../context/ConfigureContext';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useTheme, useMediaQuery } from '@mui/material';
import { toProperCase } from '../../../utils/formatRows';
import { getFinancialYearBounds } from '../../../utils/financialYear';


const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));

export default function ClientDetails({ initialData = {}, onNext, mode, connectionString, disablePartyName = false }) {
    // const API = 'http://103.251.218.254:91/api';
    const API = connectionString;
    const { user, selectedCompany, loading } = useAuth();
    const { isFeatureEnabled } = useConfigure();
    const showCurrency = isFeatureEnabled('Show Currency?');
    const companyId = selectedCompany?.CompId || null;
    const partyDropdownRef = useRef(null);
    // console.log('initialData:', initialData, mode);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    // â”€â”€â”€ client search state â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const [companyName, setCompanyName] = useState(initialData.companyName || '');
    const [BookName, setBookName] = useState('SALE');
    const [selectedClientId, setSelectedClientId] = useState(initialData.clientId || null);
    const [searchResults, setSearchResults] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(0);
    const [clientError, setClientError] = useState(false);

    const [transactionType, setTransactionType] = useState(initialData.transactionType || '')
    const isTransactionTypeValid = Boolean(transactionType);
    const [touchedTxnType, setTouchedTxnType] = useState(false);
    const [selectedGSTNum, setSelectedGSTNum] = useState("")

    // â”€â”€â”€ other form state â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const [details, setDetails] = useState(initialData.details || []);
    const [error, setError] = useState('');
    const [quotationNumber, setquotationNumber] = useState(initialData.quotationNumber || '');
    // normalize invoice/inquiry date to startOf('day') for consistent date-only handling
    const [qoutationDate, setqoutationDate] = useState(() => {
        if (mode === 'add' || mode === 'ref') return dayjs().startOf('day');
        if (initialData.inquiryDate && dayjs(initialData.inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
            return dayjs(initialData.inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
        }
        if (initialData.qoutationDate && dayjs(initialData.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
            return dayjs(initialData.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
        }
        return null;
    });
    const [referenceNumber, setReferenceNumber] = useState(initialData.referenceNumber || '');
    const [referenceDate, setReferenceDate] = useState(() => {
        const refDateValue = initialData.referenceDate || initialData.RefDate;
        return refDateValue && dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : null;
    });
    const [exchangeRate, setExchangeRate] = useState(initialData.exchangeRate || '');
    const [qnextFollowUpDate, setqnextFollowUpDate] = useState(() => {
        return initialData.nextFollowUpDate && dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().add(7, 'day').startOf('day');
    });
    const [kindAttend, setKindAttend] = useState(initialData.kindAttend || '');
    const [project, setProject] = useState(initialData.project || '');
    const [agentName, setAgentName] = useState(initialData.agentName || initialData.AgentName || '');
    const [agentCommission, setAgentCommission] = useState(initialData.AgentComm || initialData.agentCommission || '');
    const [remark, setRemark] = useState(initialData.remark || initialData.remarks || '');

    // â”€â”€â”€ masters & popups â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(initialData.selectedCurrency || null);
    const [selectedLeadSource, setSelectedLeadSource] = useState(initialData.selectedLeadSource || null);
    const [selectedEmployee, setSelectedEmployee] = useState(initialData.selectedEmployee || null);
    const [selectedActivity, setSelectedActivity] = useState(initialData.selectedActivity || null);
    const [selectedStatus, setSelectedStatus] = useState(initialData.selectedStatus || null);

    const [openClientPopup, setOpenClientPopup] = useState(false);
    const [openCurrencyPopup, setOpenCurrencyPopup] = useState(false);
    const [openLeadSourcePopup, setOpenLeadSourcePopup] = useState(false);
    const [openEmployeePopup, setOpenEmployeePopup] = useState(false);
    const [openActivityPopup, setOpenActivityPopup] = useState(false);
    const [openStatusPopup, setOpenStatusPopup] = useState(false);

    const [salesAC, setSalesAC] = useState(initialData.salesAC || '');
    const [selectedSalesACId, setSelectedSalesACId] = useState(initialData.salesACId || null);
    const [salesACResults, setSalesACResults] = useState([]);
    const [salesACDropdownOpen, setSalesACDropdownOpen] = useState(false);
    const salesACDropdownRef = useRef(null);


    const [termsOptions, setTermsOptions] = useState([]);
    const [selectedTerms, setSelectedTerms] = useState(initialData.selectedTerms || null);
    const [termsInputValue, setTermsInputValue] = useState('');



    const fetchLastTerms = async () => {
        try {
            const res = await axios.get(`${API}/api/last-terms-type`, {
                params: {
                    mode: 'DebitNote',
                    companyId
                }
            });

            const termsValue = res?.data?.TermsType;

            console.log("modeee", mode)

            // Only for add/ref mode
            if (
                termsValue &&
                (mode === 'add' || mode === 'ref')
            ) {
                setSelectedTerms({
                    label: String(termsValue)
                });
            }

        } catch (err) {
            console.error("Error fetching last terms", err);
        }
    };

    useEffect(() => {
        const fetchTerms = async () => {
            try {
                const { data: response } = await axios.get(`${API}/api/termscondition/search`, {
                    params: { companyId, mode: 'search' },
                    validateStatus: (status) => status >= 200 && status < 400,
                });
                const data = Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];
                console.log(data)
                const options = data.map(item => ({
                    label: item.TermsType || item.TermsName || ''
                }));
                setTermsOptions(options);
            } catch (err) {
                console.error('Error fetching terms:', err);
                setTermsOptions([]);
            }
        };

        if (companyId) {
            fetchTerms();
            fetchLastTerms();
        }


    }, [companyId]);

    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [paymentDays, setPaymentDays] = useState(0);
    // ðŸ”´ REPLACE THESE STATES WITH UPDATED LOGIC:
    const [invoiceNumber, setInvoiceNumber] = useState(() => {
        // For 'ref' mode: use the source invoice number from referenced quotation
        if (mode === 'ref') {
            return initialData.quotationNumber || initialData.quotationNumber || '';
        }
        // For 'edit' mode: use reference number (from debit note/credit note)
        if (mode === 'edit') {
            return initialData.invoiceNumber ||
                initialData.InvoiceNumber ||
                initialData.referenceNumber ||
                '';
        }
        // For 'add' mode: empty (user will enter or it comes from initialData)
        return initialData.invoiceNumber || '';
    });
    const [invoiceError, setInvoiceError] = useState('');

    // ──── DebitNoteNo and DebitNoteDate (user-entered) ────────────────────────────
    const [debitNoteNo, setDebitNoteNo] = useState(() => {
        const val = initialData.debitNoteNo || initialData.DebitNoteNo || '';
        if (mode === 'edit') console.log('📝 debitNoteNo initialized to:', val);
        return val;
    });
    const { startDate, endDate } = getFinancialYearBounds();
    const [debitNoteDate, setDebitNoteDate] = useState(() => {
        const dateValue = initialData.debitNoteDate || initialData.DebitNoteDate;
        if (mode === 'edit') console.log('📝 debitNoteDate dateValue:', dateValue);
        if (dateValue && dayjs(dateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
            const parsed = dayjs(dateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
            if (mode === 'edit') console.log('📝 debitNoteDate parsed to:', parsed.format('YYYY-MM-DD'));
            return parsed;
        }
        if (mode === 'add' || mode === 'ref') return dayjs().startOf('day');
        return null;
    });

    // Function to check DebitNoteNo duplication
    const checkDebitNoteDuplication = async (debitNoteValue) => {
        if (!debitNoteValue || !selectedClientId || !companyId) {
            return;
        }

        try {
            const res = await axios.get(`${API}/api/check-invoice-exists`, {
                params: {
                    DebitNoteNumber: debitNoteValue,
                    CompID: companyId,
                    PartyId: selectedClientId,
                    BookName: 'DBNT',
                    saleInvoiceId: initialData?.SaleInvoiceId || null
                }
            });

            if (res.data.exists) {
                setInvoiceError('Debit Note Number already exists for this client');
            } else {
                setInvoiceError('');
            }
        } catch (err) {
            console.error('Error checking debit note:', err);
            setInvoiceError('Error validating Debit Note Number');
        }
    };

    // Sync debitNoteNo and debitNoteDate when initialData changes (edit mode)
    useEffect(() => {
        if (mode === 'edit') {
            const newDebitNoteNo = initialData.debitNoteNo || initialData.DebitNoteNo || '';
            if (newDebitNoteNo !== debitNoteNo) {
                console.log('📝 Syncing debitNoteNo from initialData:', newDebitNoteNo);
                setDebitNoteNo(newDebitNoteNo);
            }

            const dateValue = initialData.debitNoteDate || initialData.DebitNoteDate;
            if (dateValue && dayjs(dateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
                const newDate = dayjs(dateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
                if (!debitNoteDate || !newDate.isSame(debitNoteDate)) {
                    console.log('📝 Syncing debitNoteDate from initialData:', newDate.format('YYYY-MM-DD'));
                    setDebitNoteDate(newDate);
                }
            }
        }
    }, [initialData.debitNoteNo, initialData.DebitNoteNo, initialData.debitNoteDate, initialData.DebitNoteDate, mode]);

    const [invoiceDate, setInvoiceDate] = useState(() => {
        let invDate;

        // For 'ref' mode: use source quotation date
        if (mode === 'ref') {
            invDate = initialData.qoutationDate || initialData.quotationDate;
        }
        // For 'edit' mode: use reference date
        else if (mode === 'edit') {
            invDate = initialData.referenceDate || initialData.RefDate;
        }
        // For 'add' mode: use incoming invoice date if available
        else {
            invDate = initialData.invoiceDate || '';
        }

        // Parse and validate date
        if (invDate && dayjs(invDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
            return dayjs(invDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
        }

        return null;
    });
    const parseDueDate = (value) => {
        if (!value) return dayjs();

        // YYYY-MM-DD (from parent)
        if (value.includes("-")) {
            return dayjs(value);
        }
        // DD/MM/YYYY (from backend)
        return dayjs(value, "DD/MM/YYYY");
    };

    const [dueDate, setdueDate] = useState(() => parseDueDate(initialData.dueDate));
    const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };
    const handlePopupClose = (data) => {
        if (data?.success) {
            setSnackbar({ open: true, message: data.message, severity: "success" });
        }
    };

    const checkDuplicateInvoice = async () => {
        if (!invoiceNumber || !selectedClientId || !companyId) return;

        try {
            const res = await axios.get(`${API}/api/check-invoice-exists`, {
                params: {
                    InvoiceNumber: invoiceNumber,
                    CompID: companyId,
                    PartyId: selectedClientId,
                    BookName: 'DBNT',
                    purcInvoiceId: initialData?.id || null
                }
            });

            if (res.data.exists) {
                setInvoiceError('Invoice Number already exists for this client');
            } else {
                setInvoiceError('');
            }

        } catch (err) {
            console.error('Error checking invoice:', err);
        }
    };

    // ─── only check invoice number on blur if it actually changed ──────────
    const invoiceNumberOnFocusRef = useRef(invoiceNumber);
    const handleInvoiceNumberFocus = () => {
        invoiceNumberOnFocusRef.current = invoiceNumber;
    };
    const handleInvoiceNumberBlur = () => {
        if (invoiceNumberOnFocusRef.current !== invoiceNumber) {
            checkDuplicateInvoice();
        }
    };


    const [poNumber, setPoNumber] = useState(initialData.poNumber || initialData.PONo || '');
    const [poDate, setPoDate] = useState(
        initialData.poDate &&
            dayjs(initialData.poDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
            ? dayjs(initialData.poDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
            : null
    );

    const [challanNumber, setChallanNumber] = useState(initialData.challanNumber || initialData.challanNo || '');
    const [challanDate, setChallanDate] = useState(
        initialData.challanDate &&
            dayjs(initialData.challanDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
            ? dayjs(initialData.challanDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
            : null
    );

    useEffect(() => {
        if (mode !== 'add' && mode !== 'ref') return;
        if (!companyId) return;
        const fetchDefaultSalesAC = async () => {
            try {
                const res = await axios.get(`${API}/api/getsalespurchaseclients`, { params: { field: 'FirmName', mode: 'PURC', companyId, limit: 10 } });
                const data = Array.isArray(res.data.data) ? res.data.data : [];
                if (data.length > 0) {
                    setSalesAC(data[0].FirmName || '');
                    setSelectedSalesACId(data[0].id || null);
                }
            } catch (err) {
                console.error('Error fetching default Sales A/C:', err);
            }
        };
        fetchDefaultSalesAC();
    }, [companyId, mode, API]);

    useEffect(() => {
        if (!salesACDropdownOpen || !salesAC) {
            setSalesACResults([]);
            return;
        }

        const fetchSalesAC = async () => {
            try {
                const res = await axios.get(`${API}/api/getsalespurchaseclients`, { params: { field: 'FirmName', search: salesAC, mode: 'PURC', companyId } });
                const data = Array.isArray(res.data.data) ? res.data.data : [];
                setSalesACResults(data);
            } catch (err) {
                console.error('Error fetching Sales A/C results:', err);
                setSalesACResults([]);
            }
        };
        fetchSalesAC();
    }, [salesAC, salesACDropdownOpen, companyId, API]);

    // Auto update Due Date when Invoice Date changes
    useEffect(() => {
        if (!qoutationDate) return;
        console.log("mode", mode)
        // Don't override if edit mode has dueDate
        if (mode === "edit") return;
        const baseDate = dayjs(qoutationDate);
        const due = paymentDays > 0 ? baseDate.add(paymentDays, "day") : baseDate;
        setdueDate(due);
    }, [qoutationDate, paymentDays]);

    // â”€â”€â”€ load auto-generated debit note number â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    useEffect(() => {
        if (mode === 'edit' || !companyId) return;
        fetchReceiptNo();
    }, [mode, companyId]);

    async function fetchReceiptNo() {
        try {
            const { data } = await axios.get(`${API}/api/get-sale-order-no`, { params: { companyId } });
            console.log('[STEP4] Fetched debit note number:', data);
            const invoiceNo = data.invoiceNumber || '';
            setquotationNumber(invoiceNo);
            setDebitNoteNo(invoiceNo);
        } catch (err) {
            console.error('Error fetching debit note number:', err);
            setquotationNumber('');
        }
    }

    useEffect(() => {
        if (touchedTxnType) return;
        if (selectedGSTNum === "") return;

        if (selectedGSTNum) {
            setTransactionType("Regular");  // âœ… Changed
        } else {
            setTransactionType("Unregistered Persons");  // âœ… Changed
        }
    }, [selectedGSTNum, touchedTxnType, mode, initialData.transactionType]);

    // â”€â”€â”€ load all master-lists â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    useEffect(() => {
        const fetchMasters = async () => {
            try {
                const [cur] = await Promise.all([axios.get(`${API}/currencymaster/search?mode=search&companyId=${companyId}`)]);
                setCurrencyOptions(transform(cur.data, 'CurrencyId', 'CurrencySymbol'));
            } catch (err) {
                console.error(err);
            }
        };
        fetchMasters();
    }, []);

    // â”€â”€â”€ currency selection â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    useEffect(() => {
        if (!currencyOptions || currencyOptions.length === 0 || !initialData?.currencyId) {
            setSelectedCurrency(null);
            return;
        }
        const found = currencyOptions.find(opt => String(opt.id) === String(initialData.currencyId));
        setSelectedCurrency(found || null);
    }, [currencyOptions, initialData.currencyId]);

    // â”€â”€â”€ dropdownField with popup support â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const dropdownField = (label, options, value, setValue) => (
        <Grid item xs={12} sm={8} md={12}>
            <Autocomplete fullWidth options={options} getOptionLabel={opt => opt?.label || ''} value={value} onChange={(_, v) => setValue(v)} isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)} disabled={!isEditable}
                renderInput={params => (<TextField {...params} label={label} size="small" InputLabelProps={{ shrink: Boolean(value) }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />)}
            />
        </Grid>
    );

    // â”€â”€â”€ initialize from initialData â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    useEffect(() => {
        if (!initialData || Object.keys(initialData).length === 0) {
            if (mode === 'add' || mode === 'ref') {
                setqoutationDate(dayjs().startOf('day'));
                setReferenceNumber('');
                setReferenceDate(null);
            }
            return;
        }

        // For add/ref ALWAYS use today's date for Invoice (ignore incoming inquiryDate)
        if (mode === 'add' || mode === 'ref') {
            setqoutationDate(dayjs().startOf('day'));
        }

        setCompanyName(initialData.companyName || '');
        setSelectedClientId(initialData.clientId ?? null);
        if (mode === 'edit') {
            setSelectedTerms(
                initialData.TermsType
                    ? {
                        id: initialData.TermsType,
                        label: String(initialData.TermsType)
                    }
                    : null
            );
        }

        if (initialData.details) {
            if (Array.isArray(initialData.details)) {
                setDetails(initialData.details);
            } else if (typeof initialData.details === 'object') {
                const arr = Object.entries(initialData.details).map(([label, value]) => ({ label, value }));
                setDetails(arr);
            }
        } else {
            const c = { city: initialData.city || '', state: initialData.state || '', mobileNo: initialData.mobileNo || '', emailId: initialData.emailId || '', contactPerson: initialData.contactPerson || '', gstNumber: initialData.gstNumber || '' };
            setDetails([
                { label: 'City', value: c.city },
                { label: 'State', value: c.state },
                { label: 'mobileNo', value: c.mobileNo },
                { label: 'Email', value: c.emailId },
                { label: 'ContactPerson', value: c.contactPerson },
                { label: 'GST No.', value: c.gstNumber }
            ]);
        }

        setSelectedLeadSource(initialData.selectedLeadSource || null);
        setSelectedEmployee(initialData.selectedEmployee || null);
        setSelectedActivity(initialData.selectedActivity || null);
        setSelectedStatus(initialData.selectedStatus || null);

        // Initialize quotation date: only populate from initialData when editing
        if (mode === 'edit') {
            const inquiryDate = initialData.inquiryDate || initialData.qoutationDate;
            setqoutationDate(inquiryDate && dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().startOf('day'));
        }

        if (mode === 'edit') {
            setSalesAC(initialData.salesAC || '');
            setSelectedSalesACId(initialData.salesACId || null);
        }

        // Initialize reference date and number
        if (mode === 'add') {
            setReferenceNumber(initialData.referenceNumber || '');
        } else {
            setReferenceNumber(initialData.referenceNumber || '');
            const refDateValue = initialData.referenceDate || initialData.RefDate;
            setReferenceDate(refDateValue && dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : null);
        }
        if (mode === "ref") {
            setReferenceNumber(initialData.quotationNumber);
        }

        setExchangeRate(initialData.exchangeRate || '');
        setqnextFollowUpDate(initialData.nextFollowUpDate && dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().add(7, 'day').startOf('day'));
        setKindAttend(initialData.kindAttend || '');
        setProject(initialData.project || '');
        setAgentName(initialData.AgentName || initialData.agentName || '');
        setAgentCommission(initialData.AgentComm || initialData.agentCommission || '');
        setRemark(initialData.remark || initialData.remarks || '');
        setPoNumber(initialData.poNumber || initialData.PONo || '');

        setPoDate(
            initialData.poDate &&
                dayjs(initialData.poDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
                ? dayjs(initialData.poDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
                : null
        );
        setChallanNumber(initialData.challanNumber || initialData.challanNo || '');

        setChallanDate(
            initialData.challanDate &&
                dayjs(initialData.challanDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
                ? dayjs(initialData.challanDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
                : null
        );
        setTransactionType(initialData.transactionType || "");

        if (mode === 'edit') {
            setquotationNumber(initialData.quotationNumber || '');
        }

        // ðŸ”´ UPDATED: SET INVOICE DATA BASED ON MODE (WITH DEBT NO/DATE NAMING)
        // Initialize Invoice Number and Invoice Date for reference/entry
        if (mode === 'ref') {
            // Reference mode: Load source quotation data
            setInvoiceNumber(initialData.quotationNumber || '');

            const refDate = initialData.qoutationDate || initialData.nextFollowUpDate;
            if (refDate && dayjs(refDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
                setInvoiceDate(dayjs(refDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day'));
            } else {
                setInvoiceDate(null);
            }

        } else if (mode === 'edit' && !invoiceNumber) {
            // Edit mode: Load saved invoice number/date first, falling back to reference number/date
            setInvoiceNumber(initialData.invoiceNumber || initialData.InvoiceNumber || initialData.referenceNumber || '');

            const invDate = initialData.invoiceDate || initialData.InvoiceDate;
            const refDate = initialData.referenceDate || initialData.RefDate;
            const dateToUse = invDate || refDate;
            if (dateToUse && dayjs(dateToUse, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
                setInvoiceDate(dayjs(dateToUse, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day'));
            } else {
                setInvoiceDate(null);
            }

        }
        else {
            // Add mode: Initialize from incoming data if available
            setInvoiceNumber(initialData.invoiceNumber || '');

            const invDate = initialData.invoiceDate;
            if (invDate && dayjs(invDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
                setInvoiceDate(dayjs(invDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day'));
            } else {
                setInvoiceDate(null);
            }
        }

    }, [initialData, mode]);

    // ðŸ”´ ADD THIS EFFECT BELOW:
    //set due date in edit mode
    useEffect(() => {
        if (mode === "edit" && initialData?.dueDate) {
            setdueDate(parseDueDate(initialData.dueDate));
        }
    }, [initialData, mode]);

    // â”€â”€â”€ fetch search results â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    // Debounced 350ms so a fast typist doesn't fire one API call per keystroke —
    // the search still starts automatically as the user types, just waits for a
    // brief pause before actually calling the API.
    useEffect(() => {
        if (!companyName || !dropdownOpen) {
            setSearchResults([]);
            return;
        }

        const timeoutId = setTimeout(() => {
            const fetch = async () => {
                try {
                    const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', search: companyName, companyId } });
                    const data = Array.isArray(res.data.data) ? res.data.data : [];
                    console.log('Company search results:', data);
                    setSearchResults(data);
                    setHighlightedIndex(0);
                } catch (err) {
                    console.error('Error fetching company search results:', err);
                    setSearchResults([]);
                }
            };
            fetch();
        }, 350);

        return () => clearTimeout(timeoutId);
    }, [companyName, dropdownOpen]);

    // â”€â”€â”€ Handle row selection in table â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const onSelectResult = r => {
        setSelectedClientId(r.id);
        setSelectedGSTNum(r.GSTNo);
        setTouchedTxnType(false)
        setCompanyName(r.FirmName || r.companyName || '');
        setAgentName(r.AgentName || '');
        setAgentCommission(r.AgentComm || '');
        const c = { City: r.City || '', state: r.state || '', MobileNo: r.MobileNo || '', EmailId: r.EmailId || '', ContactPerson: r.ContactPerson || '', GSTNo: r.GSTNo || '' };
        setDetails([
            { label: 'City', value: c.City },
            { label: 'State', value: c.state },
            { label: 'mobileNo', value: c.MobileNo },
            { label: 'Email', value: c.EmailId },
            { label: 'ContactPerson', value: c.ContactPerson },
            { label: 'GST No.', value: c.GSTNo }
        ]);
        // ðŸ”´ ADD THESE LINES FOR DUE DATE CALCULATION:
        const terms = Number(r.PaymentTerm || r.paymentTerm || 0);
        setPaymentDays(terms);
        const baseDate = qoutationDate ? dayjs(qoutationDate) : dayjs();
        const due = terms > 0 ? baseDate.add(terms, "day") : baseDate;
        setdueDate(due);
        setDropdownOpen(false);
        setClientError(false);
    };

    // â”€â”€â”€ Next button â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const handleNext = () => {
        if (mode === 'add' && !companyName) {
            setError('Party Name is required.');
            return;
        }
        if (!companyName && !quotationNumber) {
            setError('Party & Inquiry No. are required.');
            return;
        }
        if (!selectedClientId) {
            setClientError(true);
            return;
        }
        if (!debitNoteNo) {
            setError('Debit Note No. is required.');
            return;
        }

        // Check if there's an existing error from blur validation
        if (invoiceError) {
            setError('Please fix the Debit Note Number error before proceeding');
            return;
        }

        // log date-only values (local) so you can see IST dates
        console.log(
            'qnextFollowUpDate:', qnextFollowUpDate ? dayjs(qnextFollowUpDate).format('DD/MM/YYYY') : null,
            '| qoutationDate:', qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : null,
            '| referenceDate:', referenceDate ? dayjs(referenceDate).format('DD/MM/YYYY') : null
        );

        setError('');
        onNext({
            clientId: selectedClientId,
            companyName,
            BookName,
            quotationNumber,
            // send formatted dates (local)
            inquiryDate: qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : '',
            debitNoteNo: debitNoteNo || '',
            debitNoteDate: debitNoteDate ? dayjs(debitNoteDate).format('DD/MM/YYYY') : '',
            invoiceNumber: invoiceNumber || '',  // ðŸ”´ ADD
            invoiceDate: invoiceDate ? dayjs(invoiceDate).format('DD/MM/YYYY') : null,  // ðŸ”´ ADD
            dueDate: dueDate ? dayjs(dueDate).format('YYYY-MM-DD') : null,  // ðŸ”´ ADD
            referenceNumber,
            referenceDate: referenceDate ? dayjs(referenceDate).format('DD/MM/YYYY') : '',
            RefDate: referenceDate ? dayjs(referenceDate).format('YYYY-MM-DD') : '',
            agentName,
            agentCommission: agentCommission || 0,
            currencyId: selectedCurrency?.id || null,
            exchangeRate: exchangeRate || 0,
            kindAttend,
            remarks: remark,
            project,
            selectedEmployee,
            selectedLeadSource,
            selectedActivity,
            selectedStatus,
            transactionType,
            salesAC,
            salesACId: selectedSalesACId,
            details: details.reduce((acc, curr) => {
                acc[curr.label] = curr.value;
                return acc;
            }, {}),
            poNumber: poNumber || null,
            poDate: poDate && poDate.isValid()
                ? poDate.format('YYYY-MM-DD')
                : null,
            TermsType: selectedTerms?.label || null,
            challanNumber: challanNumber || null,
            challanDate: challanDate && challanDate.isValid() ? challanDate.format('YYYY-MM-DD')
                : null
        });
    };

    // Allow editing only in 'add' or 'edit' modes, but allow date fields in 'ref' mode
    const isEditable = mode === 'add' || mode === 'edit';
    const isDateEditable = mode === 'add' || mode === 'edit' || mode === 'ref';
    // In edit mode, disable Invoice fields if PIID exists
    const isInvoiceFieldsDisabled = mode === 'edit' && !!initialData?.PIID;

    return (
        <Paper elevation={2} sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
            <Box display="flex" justifyContent="space-between" flexWrap="wrap" pt={1}>
                <Box sx={{ width: { xs: "100%", md: "calc(47% - 20px)" }, pr: { md: 3 } }}>
                    {/* Party dropdown */}
                    <Box ref={partyDropdownRef} tabIndex={-1} sx={{ position: 'relative', flex: '1 1 40%' }}
                        onBlur={e => {
                            if (!partyDropdownRef.current.contains(e.relatedTarget)) {
                                setDropdownOpen(false);
                            }
                        }}
                    >
                        <TextField autoFocus={mode === 'add'} disabled={!isEditable || disablePartyName} fullWidth size="small" label="Party Name" variant="outlined" error={clientError} value={toProperCase(companyName)} required InputLabelProps={{ shrink: Boolean(companyName), sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: '38px', display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} helperText={clientError ? "Please select a client from the list" : ""}
                            onChange={e => {
                                setCompanyName(toProperCase(e.target.value));
                                setDropdownOpen(true);
                                setSelectedClientId(null);
                                setClientError(false);
                            }}
                            onBlur={() => {
                                if (companyName && !selectedClientId) {
                                    setClientError(true);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (!dropdownOpen || searchResults.length === 0) return;
                                if (e.key === 'ArrowDown') {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => Math.min(prev + 1, searchResults.length - 1));
                                } else if (e.key === 'ArrowUp') {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => Math.max(prev - 1, 0));
                                } else if (e.key === 'Enter') {
                                    e.preventDefault();
                                    const selected = searchResults[highlightedIndex];
                                    if (selected) {
                                        onSelectResult(selected);
                                        setCompanyName(toProperCase(selected.FirmName));
                                        setClientError(false);
                                        setDropdownOpen(false);
                                    }
                                } else if (e.key === 'Escape') {
                                    setDropdownOpen(false);
                                }
                            }}
                        />
                        {/* {dropdownOpen && (
                            <TableContainer component={Paper} elevation={0}
                                sx={{ mt: 1, maxHeight: 240, position: 'absolute', width: '120%', zIndex: 10, border: 'none', overflow: 'auto', border: '1px solid rgba(0,0,0,0.2)', borderRadius: 1 }}>
                                <Table
                                    size="small"
                                    sx={{
                                        borderCollapse: 'separate',
                                        borderSpacing: 0,
                                        tableLayout: 'fixed',              // force cells to obey widths
                                        '& thead th': {
                                            backgroundColor: '#1877F2',
                                            color: '#fff',
                                            fontWeight: 600,
                                            fontSize: '0.75rem',
                                            border: 'none'
                                        },
                                        '& th, & td': {                    // reduce padding between columns
                                            padding: '4px 6px',              // smaller vertical & horizontal padding
                                            fontSize: '0.75rem',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        },
                                        // option: collapse borders so there is no extra gap
                                        '& .MuiTableCell-root': {
                                            borderRight: '0px'               // remove right cell border if any
                                        }
                                    }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ width: '30%', maxWidth: 200 }}>Company</TableCell>
                                            <TableCell sx={{ width: '15%', maxWidth: 120 }}>GST No</TableCell>
                                            <TableCell sx={{ width: '20%', maxWidth: 140 }}>Contact</TableCell>
                                            <TableCell sx={{ width: '20%', maxWidth: 120 }}>Mobile</TableCell>
                                            <TableCell sx={{ width: '15%', maxWidth: 100 }}>City</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ '& > tr:last-of-type': { borderBottom: '1px solid rgba(0,0,0,0.12)' } }}>
                                        {searchResults.length > 0 ? (
                                            searchResults.map((r, i) => (
                                                <TableRow key={i} hover onMouseDown={() => onSelectResult(r)} sx={{ cursor: 'pointer', backgroundColor: i % 2 === 0 ? '#fff' : 'rgba(227, 242, 253, 1)', border: 'none' }}>
                                                    <TableCell sx={{ width: '30%', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.FirmName}</TableCell>
                                                    <TableCell sx={{ width: '15%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.GSTNo}</TableCell>
                                                    <TableCell sx={{ width: '20%', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.ContactPerson}</TableCell>
                                                    <TableCell sx={{ width: '20%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.MobileNo}</TableCell>
                                                    <TableCell sx={{ width: '15%', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.City}</TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={5} align="center"> No Data Available </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                    <TableFooter sx={{ borderTop: '1px solid rgba(0,0,0,0.12)' }}>
                                        <TableRow hover sx={{ cursor: 'pointer', backgroundColor: '#fff' }} onMouseDown={() => setOpenClientPopup(true)}>
                                            <TableCell colSpan={5} sx={{ textAlign: 'center', color: 'primary.main' }}>
                                                âž• Add New Client
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        )} */}
                        {dropdownOpen && companyName && (
                            <Paper elevation={0} sx={{ mt: 1, position: 'absolute', width: { xs: '100%', lg: '800px' }, zIndex: 10, border: '1px solid rgba(0,0,0,0.2)', borderRadius: 1, maxHeight: 240, overflowY: 'auto' }} >
                                {isSmallScreen ? (
                                    /* ===================== CARD VIEW (SM / XS) ===================== */
                                    <>
                                        {searchResults.length > 0 ? (
                                            searchResults.map((r, i) => (
                                                <Box key={i} sx={{ p: 1.2, borderBottom: '1px solid #eee', cursor: 'pointer', backgroundColor: i === highlightedIndex ? 'action.selected' : 'transparent' }}
                                                    onMouseEnter={() => setHighlightedIndex(i)}
                                                    onMouseDown={() => {
                                                        onSelectResult(r);

                                                        // setSelectedClientId(r.ClientId);
                                                        setCompanyName(toProperCase(r.FirmName));

                                                        setClientError(false);
                                                        setDropdownOpen(false);
                                                    }}
                                                >
                                                    <Box sx={{ fontWeight: 600, fontSize: '0.85rem' }}>  {toProperCase(r.FirmName)} </Box>
                                                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}> GST: {r.GSTNo || '-'} </Box>
                                                    <Box sx={{ fontSize: '0.75rem' }}> {toProperCase(r.ContactPerson) || '-'} â€¢ {r.MobileNo || '-'} </Box>
                                                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}> {toProperCase(r.City) || '-'} </Box>
                                                </Box>
                                            ))
                                        ) : (
                                            <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}> Client not found </Box>
                                        )}

                                        {/* Sticky Add New Client */}
                                        <Box onMouseDown={() => setOpenClientPopup(true)} sx={{ position: 'sticky', bottom: 0, backgroundColor: '#fff', textAlign: 'center', p: 1, fontWeight: 600, color: 'primary.main', cursor: 'pointer', boxShadow: '0 -2px 6px rgba(0,0,0,0.08)' }} > âž• Add New Client </Box>
                                    </>
                                ) : (
                                    /* ===================== TABLE VIEW (MD / LG) ===================== */
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map(h => (
                                                    <TableCell key={h} sx={{ backgroundColor: '#E0E0E0', fontWeight: 600, fontSize: '0.75rem', position: 'sticky', top: 0, zIndex: 1 }} > {h} </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {searchResults.length > 0 ? (
                                                searchResults.map((r, i) => (
                                                    <TableRow key={i} hover selected={i === highlightedIndex} sx={{ cursor: 'pointer' }}
                                                        onMouseEnter={() => setHighlightedIndex(i)}
                                                        onMouseDown={() => {
                                                            onSelectResult(r);

                                                            setCompanyName(toProperCase(r.FirmName));
                                                            setClientError(false);
                                                            setDropdownOpen(false);
                                                        }}
                                                    >
                                                        <TableCell>{toProperCase(r.FirmName)}</TableCell>
                                                        <TableCell>{r.GSTNo}</TableCell>
                                                        <TableCell>{toProperCase(r.ContactPerson) || "-"}</TableCell>
                                                        <TableCell>{r.MobileNo}</TableCell>
                                                        <TableCell>{toProperCase(r.City)}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}>
                                                        Client not found
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>

                                        <TableFooter
                                            sx={{
                                                position: 'sticky',
                                                bottom: 0,
                                                backgroundColor: '#fff'
                                            }}
                                        >
                                            <TableRow hover onMouseDown={() => setOpenClientPopup(true)}>
                                                <TableCell colSpan={5} align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>
                                                    âž• Add New Client
                                                </TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                )}
                            </Paper>
                        )}
                    </Box>

                    {/* Details display */}
                    <Grid item xs={12} md={4} pt={2}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Address"
                            variant="outlined"
                            disabled
                            value={
                                Array.isArray(details)
                                    ? toProperCase(details.map(d => `${d.label}: ${d.value}`).join(', '))
                                    : ''
                            }
                            multiline
                            rows={3}
                            InputLabelProps={{ shrink: Array.isArray(details) && details.length > 0 }}
                            sx={{ '& .MuiOutlinedInput-root': { display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }}
                        />
                    </Grid>

                    {/* <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Kind Attend"
                                value={kindAttend}
                                onChange={e => setKindAttend(e.target.value)}
                                InputLabelProps={{ shrink: Boolean(kindAttend) }}
                                sx={{ '& .MuiOutlinedInput-root': { height:38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                            />
                        </Box>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Project"
                                value={project}
                                onChange={e => setProject(e.target.value)}
                                InputLabelProps={{ shrink: Boolean(project) }}
                                sx={{ '& .MuiOutlinedInput-root': { height:38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                            />
                        </Box>
                    </Box> */}

                    {/* Remark multiline (max 250 chars) */}
                    <Box sx={{ mt: 2 }}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Remark"
                            disabled={!isEditable}
                            multiline
                            minRows={1}
                            maxRows={6}
                            value={remark}
                            InputLabelProps={{ shrink: Boolean(remark) }}
                            inputProps={{ maxLength: 250 }}
                            onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 250) setRemark(val);
                                else setRemark(val.slice(0, 250));
                            }}
                            sx={{ '& .MuiOutlinedInput-root': { height: 'auto', alignItems: 'flex-start' } }}
                        />
                        <Typography variant="caption" sx={{ display: 'block', mt: 0.5, textAlign: 'right', color: 'text.secondary' }}>
                            {remark.length}/250
                        </Typography>
                    </Box>

                    <Box display="flex" justifyContent="flex-start">
                        <Box
                            ref={salesACDropdownRef}
                            tabIndex={-1}
                            sx={{ flex: 1 }}
                            onBlur={(e) => {
                                if (!salesACDropdownRef.current?.contains(e.relatedTarget)) {
                                    setSalesACDropdownOpen(false);
                                }
                            }}
                        >
                            <TextField
                                fullWidth
                                required
                                label="Purchase Return A/C"
                                value={toProperCase(salesAC)}
                                InputLabelProps={{ shrink: Boolean(salesAC) }}
                                variant="outlined"
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: '38px' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' },
                                    '& .MuiFormLabel-asterisk': { color: 'red' }
                                }}
                                onChange={(e) => {
                                    setSalesAC(e.target.value);
                                    setSalesACDropdownOpen(true);
                                    setSelectedSalesACId(null);
                                }}
                                onFocus={() => {
                                    if (salesAC) setSalesACDropdownOpen(true);
                                }}
                            />

                            {salesACDropdownOpen && salesAC && (
                                <Paper
                                    elevation={0}
                                    sx={{
                                        mt: 1,
                                        position: 'absolute',
                                        width: { xs: '100%', lg: '500px' },
                                        zIndex: 10,
                                        border: '1px solid rgba(0,0,0,0.2)',
                                        borderRadius: 1,
                                        maxHeight: 240,
                                        overflowY: 'auto'
                                    }}
                                >
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map((h) => (
                                                    <TableCell
                                                        key={h}
                                                        sx={{
                                                            backgroundColor: '#E0E0E0',
                                                            fontWeight: 600,
                                                            fontSize: '0.75rem',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1
                                                        }}
                                                    >
                                                        {h}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {salesACResults.length > 0 ? (
                                                salesACResults.map((r, i) => (
                                                    <TableRow
                                                        key={i}
                                                        hover
                                                        sx={{ cursor: 'pointer' }}
                                                        onMouseDown={() => {
                                                            setSalesAC(r.FirmName);
                                                            setSelectedSalesACId(r.id);
                                                            setSalesACDropdownOpen(false);
                                                        }}
                                                    >
                                                        <TableCell>{toProperCase(r.FirmName)}</TableCell>
                                                        <TableCell>{r.GSTNo || '-'}</TableCell>
                                                        <TableCell>{toProperCase(r.ContactPerson) || '-'}</TableCell>
                                                        <TableCell>{r.MobileNo || '-'}</TableCell>
                                                        <TableCell>{toProperCase(r.City) || '-'}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}>
                                                        Sales A/C not found
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </Paper>
                            )}
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ width: { xs: "100%", md: "calc(53%)" }, pt: { xs: 2, md: 0 } }} alignSelf="right">
                    {/* DebitNoteNo + DebitNoteDate */}
                    <Box display="flex" gap={2} flex="1 1 40%">
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" label="DebitNoteNo" variant="outlined" value={debitNoteNo} onChange={(e) => setDebitNoteNo(e.target.value)} onBlur={() => checkDebitNoteDuplication(debitNoteNo)} placeholder={quotationNumber} required InputLabelProps={{ shrink: Boolean(debitNoteNo), sx: requiredAsteriskStyle }} error={!!invoiceError || (!debitNoteNo && error === 'Debit Note No. is required.')} helperText={invoiceError || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} />
                        </Box>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker label="DebitNoteDate" value={debitNoteDate} onChange={(val) => setDebitNoteDate(val ? dayjs(val).startOf('day') : null)} minDate={dayjs(startDate)} maxDate={dayjs(endDate)}
                                    slots={{
                                        textField: (params) => (
                                            <TextField {...params} size="small" fullWidth variant="outlined" sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} InputLabelProps={{ shrink: Boolean(debitNoteDate) }} />
                                        )
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    {/* Invoice No + Invoice Date */}
                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        {/* Invoice Number */}
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                label="Invoice No."
                                value={invoiceNumber}
                                onChange={e => setInvoiceNumber(e.target.value)}
                                disabled={mode === 'ref' || isInvoiceFieldsDisabled}
                                InputLabelProps={{ shrink: Boolean(invoiceNumber), sx: requiredAsteriskStyle }}
                                sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                            />
                        </Box>

                        {/* Invoice Date */}
                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="Invoice Date"
                                    value={invoiceDate}
                                    onChange={(newValue) => setInvoiceDate(newValue ? dayjs(newValue).startOf('day') : null)}
                                    disabled={mode === 'ref' || isInvoiceFieldsDisabled}
                                    slots={{
                                        textField: (params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                value={invoiceDate ? dayjs(invoiceDate).format('DD/MM/YYYY') : ''}
                                                InputLabelProps={{ shrink: Boolean(invoiceDate) }}
                                                sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                            />
                                        )
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    {/* <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                      
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                label="Ref. No."
                                value={referenceNumber}
                                onChange={e => setReferenceNumber(e.target.value)}
                                InputLabelProps={{ shrink: Boolean(referenceNumber) }}
                                sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}

                            />
                        </Box>

               
                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="Ref. Date"
                                    value={referenceDate}
                                    onChange={(newValue) => setReferenceDate(newValue ? dayjs(newValue).startOf('day') : null)}
                                    disabled={!isDateEditable}
                                    slots={{
                                        textField: (params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                value={referenceDate ? referenceDate.format('DD/MM/YYYY') : ''}
                                                InputLabelProps={{ shrink: Boolean(referenceDate) }}
                                                sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                            />
                                        )
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box> */}

                    <Box display="flex" gap={1} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 23.5%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="PO No."
                                value={poNumber}
                                onChange={(e) => setPoNumber(e.target.value)}
                                InputLabelProps={{ shrink: Boolean(poNumber) }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        height: 38,
                                        display: 'flex',
                                        alignItems: 'center'
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        fontSize: '0.875rem',
                                        padding: '0 12px'
                                    }
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: '0 0 24%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="PO Date"
                                    value={poDate}
                                    onChange={(newValue) => setPoDate(newValue)}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        width: '100%', // ADD THIS
                                        '& .MuiOutlinedInput-root': {
                                            height: 38,
                                            display: 'flex',
                                            alignItems: 'center'
                                        },
                                        '& .MuiOutlinedInput-input': {
                                            fontSize: '0.875rem',
                                            padding: '0 12px'
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true, // ALSO ADD THIS
                                            size: "small",
                                            variant: "outlined",
                                            InputLabelProps: {
                                                shrink: Boolean(poDate)
                                            }
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>

                        {/* ❌ COMMENTED: Challan No. field */}
                        {/* <Box sx={{ flex: '0 0 23.5%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Challan No."
                                value={challanNumber}
                                onChange={(e) => setChallanNumber(e.target.value)}
                                InputLabelProps={{ shrink: Boolean(challanNumber) }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        height: 38,
                                        display: 'flex',
                                        alignItems: 'center'
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        fontSize: '0.875rem',
                                        padding: '0 12px'
                                    }
                                }}
                            />
                        </Box>

                        {/* ❌ COMMENTED: Challan Dt. field */}
                        {/* <Box sx={{ flex: '0 0 24%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="Challan Dt."
                                    value={challanDate}
                                    onChange={(newValue) => setChallanDate(newValue)}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        width: '100%', // ADD THIS
                                        '& .MuiOutlinedInput-root': {
                                            height: 38,
                                            display: 'flex',
                                            alignItems: 'center'
                                        },
                                        '& .MuiOutlinedInput-input': {
                                            fontSize: '0.875rem',
                                            padding: '0 12px'
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true, // ALSO ADD THIS
                                            size: "small",
                                            variant: "outlined",
                                            InputLabelProps: {
                                                shrink: Boolean(challanDate)
                                            }
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Box> */}
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2} flexDirection={{ xs: 'column', md: 'row' }}>
                        <Box sx={{ flex: '0 0 48%', display: 'flex', gap: 1, alignItems: 'center' }}>
                            {showCurrency && (
                                <>
                                    <Box sx={{ flex: '0 0 50%' }}>
                                        {dropdownField('Currency', currencyOptions, selectedCurrency, setSelectedCurrency)}
                                    </Box>
                                    <Box sx={{ flex: '0 0 47%' }}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            type="number"
                                            variant="outlined"
                                            label="Ex Rate"
                                            value={exchangeRate}
                                            InputLabelProps={{ shrink: Boolean(exchangeRate) }}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                    setExchangeRate(value);
                                                }
                                            }}
                                            sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                        />
                                    </Box>
                                </>
                            )}
                        </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <FormControl fullWidth size="small" required sx={{
                                '& .MuiFormLabel-asterisk': {
                                    color: 'red',
                                },
                            }} error={touchedTxnType && !transactionType} >
                                <InputLabel>Transaction Type</InputLabel>
                                <Select
                                    value={transactionType}
                                    label="Transaction Type"
                                    onChange={(e) => {
                                        setTransactionType(e.target.value);
                                        setTouchedTxnType(true);
                                    }}
                                    onBlur={() => setTouchedTxnType(true)}
                                    sx={{ height: 38 }}
                                    required
                                >
                                    <MenuItem value="Regular">Regular</MenuItem>
                                    <MenuItem value="Unregistered Persons">Unregistered Persons</MenuItem>
                                    <MenuItem value="SEZ Exempted">SEZ Exempted</MenuItem>
                                    <MenuItem value="SEZ Tax Pay">SEZ Tax Pay</MenuItem>
                                    <MenuItem value="Export With Tax Pay">Export With Tax Pay</MenuItem>
                                    <MenuItem value="Export Without Tax Pay">Export Without Tax Pay</MenuItem>
                                    <MenuItem value="Exempted Supplies">Exempted Supplies</MenuItem>
                                    <MenuItem value="Nil Rate Supplies">Nil Rate Supplies</MenuItem>
                                    <MenuItem value="Non GST Supplies">Non GST Supplies</MenuItem>
                                    <MenuItem value="Composite Supplier">Composite Supplier</MenuItem>
                                    <MenuItem value="UIN holders">UIN holders</MenuItem>
                                    <MenuItem value="Import of Goods">Import of Goods</MenuItem>
                                    <MenuItem value="Import of Services">Import of Services</MenuItem>
                                    <MenuItem value="Inward Supplies of ISD">Inward Supplies of ISD</MenuItem>
                                </Select>
                            </FormControl>

                        </Box>
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField
                                fullWidth
                                label="Agent Name"
                                value={toProperCase(agentName)}
                                onChange={e => setAgentName(toProperCase(e.target.value))}
                                InputLabelProps={{ shrink: Boolean(agentName) }}
                                variant="outlined"
                                size="small"
                                sx={{ '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '38px' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' } }}
                            />
                        </Box>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField
                                fullWidth
                                label="Agent Commission (%)"
                                value={agentCommission}
                                InputLabelProps={{ shrink: Boolean(agentCommission) }}
                                variant="outlined"
                                size="small"
                                type="number"
                                onChange={e => {
                                    const v = e.target.value;
                                    if (v === '') {
                                        setAgentCommission('');
                                        return;
                                    }
                                    const re = /^(?:100(?:\.(?:0{0,2}))?|[0-9]{1,2}(?:\.\d{0,2})?)$/;
                                    if (re.test(v)) {
                                        setAgentCommission(v);
                                    }
                                }}
                                sx={{ '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '38px' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' } }}
                            />
                        </Box>
                    </Box>
                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="Due Date"
                                    value={dueDate}
                                    format="DD/MM/YYYY"
                                    minDate={qoutationDate}
                                    onChange={(v) => setdueDate(v)}
                                    slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                />
                            </LocalizationProvider>
                        </Box>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <Autocomplete
                                fullWidth
                                size="small"
                                options={termsOptions}
                                getOptionLabel={(opt) => opt?.label || ''}
                                value={selectedTerms}
                                onChange={(_, v) => setSelectedTerms(v)}
                                inputValue={termsInputValue}
                                onInputChange={(_, newInputValue) => setTermsInputValue(newInputValue)}
                                noOptionsText="Not Found"
                                isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)}
                                // disabled={!isEditable}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Terms"
                                        size="small"
                                        InputLabelProps={{ shrink: Boolean(selectedTerms || termsInputValue) }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                height: 38,
                                                display: 'flex',
                                                alignItems: 'center'
                                            },
                                            '& .MuiOutlinedInput-input': {
                                                fontSize: '0.875rem',
                                                padding: '0 12px'
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>

            {!!error && (
                <Typography color="error" mt={2}>
                    {error}
                </Typography>
            )}

            <Box mt={4} display="flex" justifyContent="flex-end">
                <Button variant="contained" onClick={handleNext} disabled={!selectedClientId || !isTransactionTypeValid || !selectedSalesACId}>Next</Button>
            </Box>

            {/* Popups */}
            <Dialog open={openClientPopup} fullWidth maxWidth="md" onClose={(event, reason) => {
                if (reason === 'backdropClick') return;
                setOpenClientPopup(false);
            }}>
                <DialogContent>
                    <ClientMaster mode="add" onPopupCancel={(data) => { handlePopupClose(data); setOpenClientPopup(false) }} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openCurrencyPopup} onClose={() => setOpenCurrencyPopup(false)}>
                <DialogContent>
                    <CurrencyMaster mode="add" onPopupCancel={() => setOpenCurrencyPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openLeadSourcePopup} onClose={() => setOpenLeadSourcePopup(false)}>
                <DialogContent>
                    <LeadSourceMaster mode="add" onPopupCancel={() => setOpenLeadSourcePopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openEmployeePopup} onClose={() => setOpenEmployeePopup(false)}>
                <DialogContent>
                    <UserMaster mode="add" onPopupCancel={() => setOpenEmployeePopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openActivityPopup} onClose={() => setOpenActivityPopup(false)}>
                <DialogContent>
                    <ActivityMaster mode="add" onPopupCancel={() => setOpenActivityPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openStatusPopup} onClose={() => setOpenStatusPopup(false)}>
                <DialogContent>
                    <LeadStatusMaster mode="add" onPopupCancel={() => setOpenStatusPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }} >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Paper>
    );
}
